export default function About() {
    return (
        <div className="max-w-5xl mx-auto mt-8 px-4 space-y-8">
            <h1 className="text-4xl font-bold">About GiftLoop</h1>
            <p>GiftLoop is a simple and collaborative gift registry app designed to make sharing and managing gift ideas easy.</p>
            <p>Users can create personal or shared registries, add items from any website using a URL, and keep track of what’s been purchased — all in one place.</p>
        </div>
    );
}
